/* eslint-disable no-restricted-imports */
/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import React from 'react';
import { FC } from 'react';
import { Typography } from '@mui/material';
import { calculateProductPrices } from 'integration/utils/calculateProductPrices';
import { formatPrice } from 'integration/utils/formatPrice';

export const PriceProductSearch: FC<{
	priceProduct: any[];
}> = ({ priceProduct }) => {
	const { priceWithoutOffer, shouldOffer } = calculateProductPrices({
		list: Number(priceProduct[0].value) || 0,
		offer: Number(priceProduct[1].value) || 0,
		ribbons: [],
	});

	return (
		<Typography
			sx={{
				fontSize: 'var(--font-size-body)',
				fontWeight: '600',
				color: '#929292',
				letterSpacing: '0px',
			}}
		>
			{shouldOffer ? formatPrice(priceWithoutOffer, 'mxn') : formatPrice(priceWithoutOffer, 'mxn')}
		</Typography>
	);
};
